<div class="mb-3">
  <label class="form-label fw-semibold text-label">
    Supervisory Level <span class="required-dot">●</span>
  </label>
  <div class="d-flex gap-3 level-cards-row">
    @for(option of roles; track option.value) {
    <div class="level-card" [class.selected]="selectedLevel === option.value" [class.has-error]="hasError"
      (click)="selectLevel(option.value)">
      <div class="d-flex align-items-center justify-content-between header-row">
        <span class="level-label" [class.selected-text]="selectedLevel === option.value">
          {{ option.label }}
        </span>
        <div class="radio-dot" [class.selected-dot]="selectedLevel === option.value"></div>
      </div>
      <div class="level-description mt-2">
        {{ option.description }}
      </div>
    </div>
    }
  </div>
  @if(hasError) {
  <div class="error-message mt-1">
    Supervisory level is required
  </div>
  }
</div>